<div class="dashboard">
  <h2 class="dashboard__heading">My Dashboard</h2>

  @if (isLoading()) {
    <app-loading />
  } @else if (!hasFavorites()) {
    <p class="dashboard__empty">
      You have not favorited any vehicles yet. Favorite a vehicle from Vehicle Maintenance to see its
      Order Guide and CFD progress here.
    </p>
  } @else {
    @for (group of yearGroups(); track trackByYear($index, group)) {
      <section class="dashboard__year">
        <h3 class="dashboard__year-heading">
          <button
            type="button"
            class="dashboard__year-toggle"
            [class.dashboard__year-toggle--expanded]="isExpanded(group)"
            [attr.aria-expanded]="isExpanded(group)"
            [attr.aria-controls]="'dashboard-year-' + group.modelYear"
            (click)="toggleYear(group)">
            <span>{{ group.modelYear }}</span>
            <icon-right-arrow />
          </button>
        </h3>

        <div class="dashboard__regions" role="tablist" [attr.aria-label]="group.modelYear + ' regions'">
          @for (region of group.regions; track region.regionId) {
            <button
              type="button"
              role="tab"
              class="dashboard__region-chip"
              [class.dashboard__region-chip--selected]="selectedRegionId(group) === region.regionId"
              [attr.aria-selected]="selectedRegionId(group) === region.regionId"
              (click)="selectRegion(group, region.regionId)">
              {{ region.regionName }}
            </button>
          }
        </div>

        @if (isExpanded(group)) {
          <div class="dashboard__year-body" [id]="'dashboard-year-' + group.modelYear">
            @for (brand of visibleBrands(group); track brand.divisionId) {
              <section class="dashboard__brand">
                <h4 class="dashboard__brand-heading">{{ brand.divisionName }}</h4>

                <div class="dashboard__vehicles">
                  @for (tile of brand.tiles; track trackByVehicleId($index, tile)) {
                    <article class="dashboard__vehicle">
                      <header class="dashboard__vehicle-header">
                        <h5 class="dashboard__vehicle-name">
                          <a [routerLink]="['/maintenance', tile.vehicle.id]">
                            {{ vehicleLabel(tile) }}
                          </a>
                        </h5>
                        <button
                          type="button"
                          class="dashboard__favorite"
                          matTooltip="Remove from My Favorites"
                          [attr.aria-label]="'Remove ' + vehicleLabel(tile) + ' from My Favorites'"
                          (click)="onRemoveFavorite(tile)">
                          <mat-icon>star</mat-icon>
                        </button>
                      </header>
                      <div class="dashboard__tiles">
                        <app-order-guide-tile
                          [tile]="tile"
                          (edit)="onEditOrderGuide($event)"
                          (copyVehicle)="onCopyVehicle($event)" />
                        @if (tile.cfd?.hasCfds) {
                          <app-cfd-tile [tile]="tile" (copyCfds)="onCopyCfds($event)" />
                        }
                      </div>
                    </article>
                  }
                </div>
              </section>
            }
          </div>
        }
      </section>
    }
  }
</div>
